import { DateTime } from "luxon";
import Image from "next/image";
import Link from "next/link";
import { PostBody } from "./styles";

export type PostType = {
  slug: string;
  frontmatter: {
      [key: string]: any;
  };
}

const Post = ({ post, hasDescription = false }: { post: PostType, hasDescription?: boolean }) => {
  //extract slug and frontmatter
  const {slug, frontmatter} = post
  //extract frontmatter properties
  const {title, date, bannerImage, description} = frontmatter

  return (
    <PostBody className={`${DateTime.now().setZone('America/New_York') < DateTime.fromISO(date, { zone: 'America/New_York' }) ? "draft" : ""}`}>
      <Link href={`/posts/${slug}`} passHref>
        <div className="image-container">
          <Image
            src={bannerImage}
            alt={title}
            fill
          />
        </div>
        <p className="subtitle">{DateTime.fromISO(date).toFormat("LLL dd, yyyy")}</p>
        <h2 className="h5">{title}</h2>
        {hasDescription ? (
          <p className="description">{description}</p>
        ) : null}
      </Link>
    </PostBody>
  )
}

export default Post;